type LogoProps = {
  variant?: 'full' | 'icon' | 'text';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizes = {
  sm: { icon: 24, height: 24 },
  md: { icon: 32, height: 32 },
  lg: { icon: 48, height: 48 },
};

// Icon component - the pink/purple gradient square with stylized "C"
function LogoIcon({ size = 32 }: { size?: number }) {
  const scale = size / 60; // Original icon is 60x60
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" rx={8.14 * scale} fill="url(#logo-gradient)" />
      <path
        d="M42.8254 50.2284C38.1991 52.1127 32.8046 51.9436 28.3099 49.7397C28.2886 49.7303 28.2674 49.7444 28.2674 49.7679V51.1447C28.2674 51.3421 28.0976 51.4878 27.9279 51.4361C23.7812 50.1908 20.2966 46.7886 17.8943 42.8038C17.8773 42.7756 17.8391 42.7897 17.8391 42.8226V46.2435C17.8391 46.4926 17.5802 46.6336 17.4019 46.4785C8.66289 38.7484 8.66289 21.6483 17.4019 13.9229C17.576 13.7678 17.8391 13.9135 17.8391 14.1578V17.0572C17.8391 17.0901 17.8773 17.1042 17.8943 17.076C20.2923 12.9878 23.7939 9.89103 27.9109 8.36381C28.0849 8.29803 28.2674 8.4484 28.2674 8.65046V9.89573C28.2674 9.91923 28.2886 9.93332 28.3099 9.92393C32.7664 7.73883 38.0845 7.55556 42.6854 9.37883C43.1565 9.56679 43.3942 10.1495 43.1947 10.657C42.3671 12.7716 41.1871 15.7743 40.351 17.889C40.1642 18.3589 39.6804 18.5703 39.2475 18.3871C35.5464 16.8129 31.1875 18.3683 28.747 21.8268C28.59 22.0524 28.2632 21.9349 28.2632 21.6483V18.6408C28.2632 18.6126 28.2377 18.5985 28.2165 18.6126C21.7184 23.246 21.7184 36.4411 28.2165 41.0745C28.2377 41.0886 28.2632 41.0745 28.2632 41.0463V38.0435C28.2632 37.7569 28.5857 37.6394 28.747 37.865C31.2512 41.4175 35.8266 42.9353 39.5785 41.1591C40.0284 40.9429 40.5505 41.1685 40.733 41.676C41.4842 43.7859 42.5962 46.9249 43.3305 48.9878C43.5088 49.4859 43.2796 50.0498 42.8254 50.2331V50.2284Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="logo-gradient"
          x1="63.49"
          y1="154.47"
          x2="-4.16"
          y2="153.50"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCAF0" />
          <stop offset="1" stopColor="#B957FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

// Text component — "TheContent"
function LogoText({ height = 32 }: { height?: number }) {
  const fontSize = height * 0.65;
  return (
    <span
      className="font-heading font-bold text-foreground select-none"
      style={{ fontSize: `${fontSize}px`, lineHeight: `${height}px` }}
    >
      TheContent
    </span>
  );
}

export function Logo({ variant = 'full', size = 'md', className = '' }: LogoProps) {
  const { icon: iconSize, height } = sizes[size];

  if (variant === 'icon') {
    return (
      <div className={className}>
        <LogoIcon size={iconSize} />
      </div>
    );
  }

  if (variant === 'text') {
    return (
      <div className={className}>
        <LogoText height={height} />
      </div>
    );
  }

  // Full variant: icon + text
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoIcon size={iconSize} />
      <LogoText height={height} />
    </div>
  );
}
